/* React Higher Order Component which fetches activity data for project where projectId = props.projectId
    Child (InnerComponent) will only render once activity data is successfully fetched.
    child will receive props: {
        projectId: PropTypes.number,
        fatalError: PropTypes.object,
        activityStoreState: PropTypes.shape({ initialized: PropTypes.bool, activities: PropTypes.object, activitySaves: PropTypes.object, ... })
    }

*/

import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');

const ActivityActions = require('../../actions/ActivityActions');
const ActivityStore = require('../../stores/activity_store_reflux');
import LoadingMainContent from '../loading/LoadingMainContent';
import ErrorBox from '../common/ErrorBox';
const ReactUtil = require('../../util/ReactUtil');

const propTypes = {
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    forceRefreshOnMount: PropTypes.bool, // force refresh of activity data, even if activity store already has data for the given id
    hideLoadingIcon: PropTypes.bool
};

const defaultProps = {
    forceRefreshOnMount: false,
    hideLoadingIcon: false
};

export default function withProjectActivities(WrappedComponent) {
    class WithProjectActivities extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                activityStoreState: ActivityStore.getStateProject(props.projectId, props.channelId),
                getActionId: null,
                fatalError: null
            }

            this.unsubscribes = [ActivityStore.listen(this.onActivityStoreChange.bind(this))];
        }

        componentDidMount() {
            if (!this.state.activityStoreState.initialized || this.props.forceRefreshOnMount) {
                const actionId = uuid.v4();
                this.setState({ getActionId: actionId }, () => {
                    ActivityActions.getProjectActivities(actionId, { projectId: this.props.projectId, channelId: this.props.channelId });
                })
            }
        }

        componentWillUnmount() {
            this.unsubscribes.forEach(u => u());
        }

        onActivityStoreChange(newState) {
            let additionalState = {};
            if (newState.action.id === this.state.getActionId) {
                additionalState = { ...additionalState, getActionId: null };

                if (!!newState.action.error) {
                    additionalState = { ...additionalState, fatalError: newState.action.error };
                }

            }

            this.setState({
                activityStoreState: ActivityStore.getStateProject(this.props.projectId, this.props.channelId),
                ...additionalState
            });
        }

        render() {
            if (this.state.fatalError) {
                return <ErrorBox error={this.state.fatalError} />;
            }

            if (!this.state.activityStoreState.initialized) {
                if (this.props.hideLoadingIcon) {
                    return null;
                }
                else {
                    return <LoadingMainContent />;
                }
            }

            return (
                <WrappedComponent
                    {...this.props}
                    activityStoreState={this.state.activityStoreState}
                />
            );
        }
    }

    WithProjectActivities.propTypes = propTypes;
    WithProjectActivities.defaultProps = defaultProps;
    WithProjectActivities.displayName = `WithProjectActivities(${ReactUtil.getComponentDisplayName(WrappedComponent)})`
    return WithProjectActivities;
}
